import {OrderItemInterface} from "@/types/OrderItem";
import {Member} from "@/util/Member";
import {Event} from "@/util/Event";
import {v4 as uuid} from 'uuid';
import {DiscountCheckInterface} from "@/types/DiscountCheck";

export class OrderItem implements OrderItemInterface {
  id: string;
  memberId: string;
  eventId: string | number;
  price: number;
  productId: string | number;
  qty: number;
  ticketCategoryId: string | number;
  discount?: DiscountCheckInterface

  constructor({id, eventId, price, productId, qty, ticketCategoryId, memberId, discount}: OrderItemInterface) {
    this.id = id;
    this.memberId = memberId;
    this.eventId = eventId;
    this.price = this.getPrice(price, discount)
    this.productId = productId;
    this.qty = qty;
    this.ticketCategoryId = ticketCategoryId;
    this.discount = discount;
  }

  getPrice(price: any, discount: any){
    if(discount){
      return parseFloat(discount.productPrice)
    }
    return price;
  }

  static create(member:Member, event:Event, qty = 1): OrderItem | undefined {
    if(!member.ticketCategoryId) {
      return undefined;
    }
    const ticketCategory = event.ticketCategory(member.ticketCategoryId);

    if(!ticketCategory) {
      return undefined;
    }

    return new this({id:uuid(),memberId: member.id, price:ticketCategory.price, eventId:event.id, ticketCategoryId:member.ticketCategoryId, productId:ticketCategory.productId, qty, discount: member.discount})
  }
}
